import React from 'react'
import _ from 'lodash'
import { getMyUser } from '../../api/'
import AppState from '../../state/AppState';

export default function (WrappedComponent, onNoSession = _.noop) {

  return class extends React.Component {

    constructor(props) {
      super(props);

      this.state = {
        isCheckingSession: true,
        isLoggedIn: false,
        hasOrgs: false
      }
    }

    componentDidMount() {
      getMyUser({ withorgs: true }).then((result) => {

        this.setState({
          isCheckingSession: false,
          isLoggedIn: true,
          hasOrgs: result.orgs.items.length > 0
        });

        AppState.setUser(result.user);
        AppState.setOrgs(result.orgs.items);

      }).catch((e) => {
        this.setState({
          isCheckingSession: true,
          isLoggedIn: false
        });
        onNoSession();
      });
    }

    render() {

      const { isCheckingSession, isLoggedIn, hasOrgs } = this.state;

      return (
        <div className="CheckSessionHOC">
          <WrappedComponent isCheckingSession={isCheckingSession}
                            isLoggedIn={isLoggedIn}
                            hasOrgs={hasOrgs}
                            {...this.props} />
        </div>
      )
    }

  }

}


// WEBPACK FOOTER //
// ./src/components/user/CheckSessionHOC.js